module.exports = __webpack_public_path__ + "img/水环境监测预警平台.007d8e7d.png";